import { inject } from 'aurelia';
import { MessagesApi } from '../../apis/messages/messages-api';
import { Message } from '../../components/callout/message';
import { MessageType } from '../../components/callout/message-type';
import { MessageEntity } from '../../apis/messages/message-entities';
import { I18N } from '@aurelia/i18n';
import { HttpErrorHelper } from '../../infrastructure/error/http-error-helper';
@inject(MessagesApi, I18N, HttpErrorHelper)
export class About {
    public email: string = null;
    public message: string = null;
    public messages: Message[] = [];
    public captcha: boolean = false;
    private _messagesApi: MessagesApi;
    private _i18n: I18N;
    private _httpErrorHelper: HttpErrorHelper;

    constructor(messagesApi: MessagesApi, i18n: I18N, httpErrorHelper: HttpErrorHelper) {
        this._messagesApi = messagesApi;
        this._i18n = i18n;
        this._httpErrorHelper = httpErrorHelper;
    }
    public async send(): Promise<void> {
        try {
            this.messages.clear();
            const messageDto = new MessageEntity();
            messageDto.email = this.email;
            messageDto.message = this.message;
            await this._messagesApi.send(messageDto);
            this.email = null;
            this.message = null;
            this._addMessage(this._i18n.tr('ui:message_sent'), MessageType.info);
        } catch (err) {
            this._handleErrors(err);
        }
    }

    public get canSend(): boolean {
        return !!this.email?.trim() && !!this.message?.trim() && this.captcha;
    }

    public onVerified(response: any): void {
        if (response) {
            this.captcha = true;
        }
    }

    private _addMessage(text: string, type: MessageType): void {
        const message = new Message(text, type);
        this.messages.add(message);
    }

    private _handleErrors(err: any): void {
        const errors = this._httpErrorHelper.getTranslatedHttpErrors(err);
        for (const error of errors) {
            this.messages.add(new Message(error.message, MessageType.danger));
        }
    }
}
